"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _lodash = _interopRequireDefault(require("lodash.clonedeep"));

var _BrandButton = _interopRequireDefault(require("../../../Button/BrandButton"));

var _spacing = _interopRequireDefault(require("../../../../constants/spacing"));

var _colors = _interopRequireDefault(require("../../../../constants/colors"));

var _vars = _interopRequireDefault(require("../../../../constants/vars"));

var _Tick = _interopRequireDefault(require("../../../Icons/Tick"));

var _NotAllowed = _interopRequireDefault(require("../../../Icons/NotAllowed"));

var _stripUnit = _interopRequireDefault(require("../../../../utils/stripUnit"));

var _CancelLink = _interopRequireDefault(require("../../Elements/CancelLink"));

var _Actions = _interopRequireDefault(require("../../Elements/Actions"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tbackground-color: ", ";\n\tmargin-top: ", ";\n\tpadding: ", ";\n\tborder: ", " solid;\n\tborder-color: ", ";\n\tborder-radius: ", ";\n\tcursor: pointer;\n\t:hover {\n\t\t", ";\n\t\t", ";\n\t\t", ",\n\t\t", " {\n\t\t\tfill: ", " !important;\n\t\t}\n\t}\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\twidth: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: block;\n\tfont-size: ", ";\n\tcolor: ", ";\n\t", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: block;\n\tfont-size: ", ";\n\tfont-weight: 600;\n\t", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tfill: ", " !important;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tfill: ", " !important;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\ttop: 50%;\n\tbottom: 50%;\n\ttransform: translate(-50%, -50%);\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: ", " !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var inactiveBorderMixin = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.inactive ? _colors.default.greyLight : _colors.default.primaryDark;
});
var inactiveLabelColorMixin = (0, _styledComponents.css)(_templateObject2(), function (props) {
  return props.inactive && "color: " + _colors.default.greyLight + " !important";
});
var ICON_SIZE = (0, _stripUnit.default)(_spacing.default.s3);
var iconStyleMixin = (0, _styledComponents.css)(_templateObject3());
var Tick = (0, _styledComponents.default)(_Tick.default)(_templateObject4(), iconStyleMixin, function (props) {
  return props.selected ? _colors.default.primaryDark : _colors.default.greyLight;
});
Tick.displayName = 'Tick';
var NotAllowed = (0, _styledComponents.default)(_NotAllowed.default)(_templateObject5(), iconStyleMixin, _colors.default.greyLight);
NotAllowed.displayName = 'NotAllowed';

var PrimaryLabel = _styledComponents.default.span(_templateObject6(), _spacing.default.s2, inactiveLabelColorMixin);

PrimaryLabel.displayName = 'PrimaryLabel';

var SecondaryLabel = _styledComponents.default.span(_templateObject7(), _spacing.default.s2, _colors.default.greyDark, inactiveLabelColorMixin);

SecondaryLabel.displayName = 'SecondaryLabel';

var IconContainer = _styledComponents.default.div(_templateObject8(), _spacing.default.s1);

IconContainer.displayName = 'IconContainer';

var Option = _styledComponents.default.div(_templateObject9(), function (props) {
  return props.selected ? _colors.default.bodyBackground : _colors.default.white;
}, _spacing.default.s1, _spacing.default.s2, _vars.default.borderWidth, function (props) {
  return props.selected ? _colors.default.primaryLight : _colors.default.greyLight;
}, _vars.default.borderRadius, inactiveBorderMixin, function (props) {
  return props.inactive && 'cursor: not-allowed';
}, Tick, NotAllowed, function (props) {
  return props.inactive ? _colors.default.greyLight : _colors.default.primaryDark;
});

Option.displayName = 'Option';

var DayPartOverlay =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DayPartOverlay, _React$Component);

  function DayPartOverlay(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      options: props.options
    };
    return _this;
  }

  var _proto = DayPartOverlay.prototype;

  _proto.select = function select(selectedOptionId) {
    // eslint-disable-next-line react/no-access-state-in-setstate
    var options = (0, _lodash.default)(this.state.options);
    var currentSelection = options.find(function (o) {
      return o.selected;
    });
    currentSelection.selected = false;
    options.find(function (o) {
      return o.id === selectedOptionId;
    }).selected = true;
    this.setState({
      options: options
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var options = this.state.options;
    var _this$props = this.props,
        onApply = _this$props.onApply,
        onCancel = _this$props.onCancel;
    return _react.default.createElement("div", null, _react.default.createElement("div", null, options.map(function (option) {
      return _react.default.createElement(Option, {
        "data-testid": "option",
        key: option.id,
        selected: option.selected,
        inactive: option.disabled,
        onClick: function onClick() {
          return !option.disabled && _this2.select(option.id);
        }
      }, _react.default.createElement("div", null, _react.default.createElement(PrimaryLabel, {
        inactive: option.disabled
      }, option.label), _react.default.createElement(SecondaryLabel, {
        inactive: option.disabled
      }, option.duration)), _react.default.createElement(IconContainer, null, option.disabled ? _react.default.createElement(NotAllowed, {
        size: ICON_SIZE,
        "data-testid": "not allowed"
      }) : _react.default.createElement(Tick, {
        selected: option.selected,
        size: ICON_SIZE,
        "data-testid": "tick"
      })));
    })), _react.default.createElement(_Actions.default, null, _react.default.createElement(_CancelLink.default, {
      onClick: function onClick() {
        return onCancel();
      }
    }, "Cancel"), _react.default.createElement(_BrandButton.default, {
      onClick: function onClick() {
        return onApply([].concat(options));
      }
    }, "Apply")));
  };

  return DayPartOverlay;
}(_react.default.Component);

DayPartOverlay.displayName = 'DayPartOverlay';
DayPartOverlay.propTypes = {
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.number,
    label: _propTypes.string,
    duration: _propTypes.string,
    selected: _propTypes.bool,
    disabled: _propTypes.bool
  })).isRequired,
  onCancel: _propTypes.func.isRequired,
  onApply: _propTypes.func.isRequired
};
var _default = DayPartOverlay;
exports.default = _default;